/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue').default;

import router from './router'
import store from './store'
import Vuetify from './plugins/vuetify'
import VueAxios from "vue-axios"
import axios from 'axios'
import { VueMaskDirective } from 'v-mask'

Vue.use(VueAxios, axios)
Vue.directive('mask', VueMaskDirective)

const app = new Vue({
    el: '#app',
    vuetify: Vuetify,
    router:router,
    store:store,
});
